import { MenuItems, MenuItem } from '@ers/data/';
import { NotImplementedMenuTypeError } from '@ers/errors/';

// eslint-disable-next-line import/prefer-default-export
export class RouteHelper {
    static getItemByType(type) {
        const item = MenuItems.find((i) => i.type === type);
        if (item) return item;
        throw new NotImplementedMenuTypeError(type);
    }

    static getActiveItemByPath(path) {
        const matchedItem = MenuItems.find((t) => t.regex && t.regex.test(path));
        if (matchedItem) return RouteHelper.getItemByType(matchedItem.type);
        return null;
    }

    static getPathByType(type) {
        return MenuItem.get(type).pattern;
    }
}
